import {useEffect, useState} from 'react'
import {CompanyModel} from '../../central/model'
import {getCompany} from '../../central/services'

export const useCompanies = () => {
  const [companyData, setCompanyData] = useState<CompanyModel[] | any>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const getCompanyList = async () => {
    setIsLoading(true)
    try {
      const response = await getCompany({isCombo: true}, 1)
      let data = response.data.data
      const mappedSites = data.map((item) => ({value: item.id, label: item.nombreEmpresa}))
      setCompanyData(mappedSites)
      setIsLoading(false)
    } catch (error) {}
  }

  useEffect(() => {
    getCompanyList()
  }, [])

  return {isLoading, companyData}
}
